import NewsletterEighteenContainer from "./containers/NewsletterEighteenContainer";
export default NewsletterEighteenContainer;
